import React,{useState,useEffect, useRef} from 'react'
import { useParams } from 'react-router-dom';
import chatbotServices from '../chatbotServices';
import { Attachment, Phone, Send } from '@mui/icons-material';
import ConversationView from '../components/ConversationView';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ChatAudioInput from '../components/ChatAudioInput';
import ChatLocationInput from '../components/ChatLocationInput';
import ChatImageInput from '../components/ChatImageInput';

function ChatPage() {
    const messagesEndRef = useRef(null);
    const [messageInput,setMessageInput] = useState("");
    const [conversationList,setConversationList] = useState([]);
    const [loading,setLoadingStatus] = useState(false);

    const [phoneNoInput,setPhoneNoInput] = useState("");
    const [chatUserPhone,setChatUserPhone] = useState(JSON.parse(sessionStorage.getItem("chatUserPhone"))); 
    const [dialogStatus, setDialogStatus] = useState(false);
    const [nextPayload,setNextPayload] = useState(null);


    const updateConversation = (message,type,dataType="text") =>{
		let _message = {
			msg : message,
			type : type,
			dataType:dataType,
		}
		//let _conversationList = [...conversationList,_message]; // bug when use this method two time in one function
		setConversationList(_conversationList=>[..._conversationList,_message])		
		setMessageInput("");
	}


    const handleResponse = (res) =>{
		setTimeout(()=>{
			if(res.data !==null){
                console.log(res.data);
                if(res.data.messageType === "askPhoneNo"){
                    setNextPayload(res.postData);
                    setDialogStatus(true);
                } else {
                    updateConversation(res.data,"i")
                }
			}
			setLoadingStatus(false)
		},[1000])
	}

    const sendTextMessage = () =>{
		let payload = {
			messageType : "text",
			message:messageInput,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		updateConversation(messageInput,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const sendInterectiveMessage = (option,messageType) =>{
		let payload = {
			messageType : messageType,
			id:option.optionId,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		console.log(option)
		updateConversation(option.optionTitle,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const sendImageMessage = (url) =>{
		let payload = {
			messageType : "imageRequest",
			url:url,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(url,"o","image")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendAudioMessage = (url) =>{
		let payload = {
			messageType : "audioRequest",
			url:url,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(url,"o","audio")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendLocationMessage = (location) =>{
		let payload = {
			messageType : "locationRequest",
			location:location,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(location,"o","location")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const handlePhoneNoChange = () =>{
        sessionStorage.setItem("chatUserPhone",phoneNoInput);
        setChatUserPhone(phoneNoInput);
        setLoadingStatus(true);
        let payload = {...nextPayload};
        payload.from = phoneNoInput;
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
            setNextPayload(null);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{
            setLoadingStatus(false);	
            setDialogStatus(false);	
		})
    }

	const initiateConversation = () =>{
		let payload = {
			messageType : "text",
			message:"hi",
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		//updateConversation("hi","o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    useEffect(()=>{
		if(conversationList.length === 0){
			initiateConversation();
		}
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	},[conversationList])

    return (
        <div className='container p-0'>
            <div className='card p-0'>
                <div className='card-header bg-primary text-white' style={{height:"8vh"}}>G-Help</div>
                <div className='card-body' style={{height:"82vh", overflowY:"scroll"}}>
                    <ConversationView conversationList={conversationList} sendInterectiveMessage={sendInterectiveMessage} />
					{loading && <div className='p-3'><CircularProgress /></div> }
					<div ref={messagesEndRef} />
                </div>
                <div className='card-footer bg-white p-0 border-0' style={{height:"8vh"}}>
                    <div className="input-group">
                        {chatUserPhone !== null &&
                        <button type="button" className="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown">
							<Attachment />
						</button>
                        }

                        <ul className="dropdown-menu">
							<li><ChatImageInput callBack={sendImageMessage} chatUserPhone={chatUserPhone} /></li>
							<li><ChatLocationInput callBack={sendLocationMessage} /></li>
						</ul>
                        
                        <input type="text" className="form-control bg-light" placeholder="Message"
							value={messageInput}
							onChange={(e)=>setMessageInput(e.target.value)}
							onKeyUp={ (e) =>{
								if(e.key === 'Enter') {
									e.preventDefault();
									sendTextMessage()
								}
							}}
						/>
                        {chatUserPhone !== null && <ChatAudioInput callBack={sendAudioMessage} chatUserPhone={chatUserPhone} /> }
                        <button className="btn btn-outline-secondary text-success" type="button" id="button-addon3" onClick={sendTextMessage}><Send /></button>
                    </div>
                </div>
            </div>

            <Dialog
				open={dialogStatus}
				keepMounted
				onClose={()=>setDialogStatus(false)}
				maxWidth="sm"
				fullWidth={true}
			>
                <DialogTitle>Your Phone No to Continue.</DialogTitle>
                <DialogContent>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <div className="input-group mb-3">
                                <span className="input-group-text"><Phone/></span>
                                <input type="number" className="form-control" placeholder="Your Phone Number" 
                                    value={phoneNoInput}
                                    onChange={(e)=>setPhoneNoInput(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button onClick={()=>setDialogStatus(false)} className='btn btn-outline-primary'>Cancel</button>
                    <button disabled={phoneNoInput.length < 10} onClick={handlePhoneNoChange} className='btn btn-primary'>Continue</button>
                </DialogActions>
            </Dialog>
        </div>
        
    )
}

export default ChatPage